import React from 'react';
import { Page, Text, Document, StyleSheet, View, Image } from '@react-pdf/renderer';

// Define styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize:12,
        fontFamily: 'Helvetica',
    },
    header: {
        marginBottom: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    // logo: {
    //     width: 100,
    //     height: 50,
    // },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    section: {
        marginBottom: 15,
        paddingBottom: 10,
        borderBottom: '1px solid #ddd',
    },
    customerInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontSize: 12,
        marginBottom: 10,
    },
    table: {
        display: 'table',
        width: 'auto',
        marginVertical: 10,
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableHeader: {
        fontSize: 10,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        padding: 5,
        backgroundColor: '#f3f3f3',
        borderBottom: '1px solid #ddd',
        borderTop: '1px solid #ddd',
    },
    tableCell: {
        fontSize: 10,
        padding: 5,
    },
    tableHeaderCell: {
        flex: 1,
    },
    footer: {
        fontSize: 10,
        marginTop: 20,
        textAlign: 'center',
        color: '#888',
    },
    totalSection: {
        marginTop: 15,
        fontSize: 12,
        textAlign: 'right',
    },
    bold: {
        fontWeight: 'bold',
    },
});

// Invoice PDF Component
const InvoicePDF = ({ detailData, itemData, logoUrl }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header}>
                {/* <Image style={styles.logo} src={logoUrl} /> */}
                <Text style={styles.title}>Invoice</Text>
            </View>

            {/* Customer and Invoice Info */}
            <View style={[styles.section, { flexDirection: 'row', justifyContent: 'space-between' }]}>
                <View>
                    <Text style={[styles.bold]}>Customer:</Text>
                    <Text>{detailData?.customer_name}</Text>
                    <Text>{detailData?.address}</Text>
                </View>
                <View>
                    <Text style={[styles.bold]}>Invoice Details:</Text>
                    <Text>Transaction No: {detailData?.no_transaction}</Text>
                    <Text>Date: {detailData?.date}</Text>
                    <Text>Due Date: {detailData?.due_date}</Text>
                </View>
            </View>

            {/* Items Table */}
            <View style={styles.table}>
                {/* Table Header */}
                <View style={[styles.tableRow, styles.tableHeader]}>
                    <Text style={[styles.tableHeaderCell, { flex: 3 }]}>Product</Text>
                    <Text style={[styles.tableHeaderCell, { flex: 4 }]}>Description</Text>
                    <Text style={[styles.tableHeaderCell, { flex: 1, textAlign: 'right' }]}>Qty</Text>
                    <Text style={[styles.tableHeaderCell, { flex: 1, textAlign: 'right' }]}>Unit Price</Text>
                    <Text style={[styles.tableHeaderCell, { flex: 1, textAlign: 'right' }]}>Discount</Text>
                    <Text style={[styles.tableHeaderCell, { flex: 1, textAlign: 'right' }]}>Tax</Text>
                    <Text style={[styles.tableHeaderCell, { flex: 2, textAlign: 'right' }]}>Amount</Text>
                </View>

                {/* Table Rows */}
                {itemData?.map((item, index) => (
                    <View key={index} style={styles.tableRow}>
                        <Text style={[styles.tableCell, { flex: 3 }]}>{item?.product_name}</Text>
                        <Text style={[styles.tableCell, { flex: 4 }]}>{item?.description}</Text>
                        <Text style={[styles.tableCell, { flex: 1, textAlign: 'right' }]}>{item?.quantity}</Text>
                        <Text style={[styles.tableCell, { flex: 1, textAlign: 'right' }]}>
                            {parseFloat(item?.unit_price).toLocaleString('id-ID')}
                        </Text>
                        <Text style={[styles.tableCell, { flex: 1, textAlign: 'right' }]}>{item?.discount}%</Text>
                        <Text style={[styles.tableCell, { flex: 1, textAlign: 'right' }]}>{item?.tax_name}</Text>
                        <Text style={[styles.tableCell, { flex: 2, textAlign: 'right' }]}>
                            {parseFloat(item?.amount).toLocaleString('id-ID')}
                        </Text>
                    </View>
                ))}
            </View>

            {/* Totals */}
            <View style={styles.totalSection}>
                <Text>
                    <Text style={styles.bold}>Subtotal:</Text> Rp {parseFloat(detailData?.subtotal_amount).toLocaleString('id-ID')}
                </Text>
                <Text>
                    <Text style={styles.bold}>Tax:</Text> Rp {parseFloat(detailData?.tax_amount).toLocaleString('id-ID')}
                </Text>
                <Text>
                    <Text style={styles.bold}>Total:</Text> Rp {parseFloat(detailData?.amount).toLocaleString('id-ID')}
                </Text>
                <Text>
                    <Text style={styles.bold}>Outstanding Amount:</Text> Rp{' '}
                    {parseFloat(detailData?.outstanding_amount).toLocaleString('id-ID')}
                </Text>
            </View>

            {/* Footer */}
            <Text style={styles.footer}>
                Last updated by {detailData?.updated_by} on {detailData?.updated_at}.
            </Text>
        </Page>
    </Document>
);

export default InvoicePDF;
